import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  fieldSrList: {},
  forceShowError: false,
  isNewSrFieldsValid: true,
  srStatus: {},
};

export const fieldValidationsSlice = createSlice({
  name: 'fieldValidations',
  initialState,
  reducers: {
    updateFieldValidationStatus: (state, action) => {
      const { srId, fieldName, required, isValid } = action.payload;
      if (!srId) return;
      state.fieldSrList[srId] = state.fieldSrList[srId] || {};
      state.fieldSrList[srId][fieldName] = state.fieldSrList[srId][fieldName] || {};
      state.fieldSrList[srId][fieldName].required = required;
      state.fieldSrList[srId][fieldName].isValid = isValid;
      if (srId === 'new') {
        state.isNewSrFieldsValid = true;
        const fieldSr = state.fieldSrList[srId];
        const fieldSrValues = Object.values(fieldSr);
        for (const property in fieldSrValues) {
          if (fieldSrValues[property].isValid === false) {
            state.isNewSrFieldsValid = false;
            break;
          }
        }
      }
    },
    updateSrStatusValue: (state, action) => {
      const { srId, srStatusValue } = action.payload;
      // state.srStatus = {};
      state.srStatus[srId] = srStatusValue;
    },
    resetFieldValidationStatus: (state, action) => {
      state.fieldSrList = !action.payload && {};
    },
    setForceShowError: (state, action) => {
      state.forceShowError = action.payload;
    },
  },
});
export const selectFieldValidations = (allSliceState) => allSliceState.fieldValidations;
export const selectForceShowValidationError = (allSlicesState) => allSlicesState.fieldValidations.forceShowError;
export const selectFieldSrList = (allSlicesState) => allSlicesState.fieldValidations.fieldSrList;
export const selectIsNewSrFieldsValid = (allSlicesState) => allSlicesState.fieldValidations.isNewSrFieldsValid;
export const selectSrStatusValue = (allSlicesState) => allSlicesState.fieldValidations.srStatus;

export const { updateFieldValidationStatus, updateSrStatusValue, resetFieldValidationStatus, setForceShowError } =
  fieldValidationsSlice.actions;
export default fieldValidationsSlice.reducer;
export const fieldValidationsSliceName = fieldValidationsSlice.name;
